export default "__VITE_ASSET__Ccvv7ARB__"